import { formatDate } from './formatDate';

/**
 * Formats the SLA deadline timestamp for tooltip display
 * @param dueDateTime - ISO 8601 date-time string
 * @param slaType - Type of SLA: 'response' or 'resolve'
 * @param t - Translation function
 * @returns Formatted tooltip string or null if dueDateTime is missing
 */
export const formatSlaDeadlineTooltip = (
  prefix: 'task_header' | 'task_list',
  dueDateTime: string | undefined,
  slaType: 'response' | 'resolve',
  t: (key: string, options?: Record<string, string | number>) => string,
): string | null => {
  if (!dueDateTime) {
    return null;
  }

  try {
    const date = formatDate(dueDateTime, 'dd MMM yyyy');
    const time = formatDate(dueDateTime, 'HH:mm');

    if (!date || !time) {
      return null;
    }

    const tooltipText = t(`${prefix}:sla:${slaType}:toast_date_time`, { date, time });

    // Format: "Resolution time ends: 24 Oct 2025 at 14:43"
    return tooltipText;
  } catch (err) {
    return null;
  }
};
